import { affidavitRepository } from './repository';
import AffidavitService from './service/AffidavitServiceImpl';

const affidavitService = new AffidavitService(affidavitRepository);

export { affidavitService };
